// api
import { fetchApi } from '@/api'
// actions
const restaurantProductsAll = (context) => {
  let url = 'inventory/products/productsRestaurant'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_PRODUCTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsForm = (context) => {
  let url = 'inventory/products/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_PRODUCTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsShow = (context, payload) => {
  console.log(payload)
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/' + obj.id + '/editRest'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_PRODUCTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const restaurantProductsCreate = (context, payload) => {
  let url = 'inventory/products/createRestautant'
  return fetchApi(url, payload, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_PRODUCTS_CREATE', response)
     // window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_PRODUCTS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantProductsAdd = (context, payload) => {
  let obj = JSON.parse(payload)
  var count = prompt('Ingrese la cantidad')
  if (count != null) {
    obj.count = count
    let json = JSON.stringify(obj)
    let url = 'inventory/products/' + obj.id + '/add'
    return fetchApi(url, json, 'POST')
      .then((response) => {
        context.commit('RESTAURANT_PRODUCTS_ADD', response)
        location.reload()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

const restaurantProductsMinus = (context, payload) => {
  let obj = JSON.parse(payload)
  var count = prompt('Ingrese la cantidad')
  if (count != null) {
    obj.count = count
    let json = JSON.stringify(obj)
    let url = 'inventory/products/' + obj.id + '/minus'
    return fetchApi(url, json, 'POST')
      .then((response) => {
        context.commit('RESTAURANT_PRODUCTS_MINUS', response)
        location.reload()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

export default {
  restaurantProductsAll,
  restaurantProductsForm,
  restaurantProductsShow,
  restaurantProductsCreate,
  restaurantProductsUpdate,
  restaurantProductsDelete,
  restaurantProductsAdd,
  restaurantProductsMinus
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/actions.js